export default (onboarding_progress) => {
  let nextPage = {};
  if (onboarding_progress && onboarding_progress.length > 0) {
    const unresolvedPages = onboarding_progress.filter((page) => page.completed == false);
    const currentIndex = onboarding_progress.findIndex((page) => page.url == window.location.pathname);

    nextPage.url = "/datapulse/onboarding/complete";
    // Find next unresolved page starting from current index
    for (let i = currentIndex + 1; i < onboarding_progress.length; i++) {
      if (onboarding_progress[i].completed == false) {
        nextPage = onboarding_progress[i];
        // Break out of loop
        i = onboarding_progress.length;
      }
    }

    // Override last page if not actually complete
    if (nextPage.url == "/datapulse/onboarding/complete") {
      // Greater than 2 because counting current page & /datapulse/onboarding/complete is also a page
      if (unresolvedPages.length >= 2) {
        nextPage.url = "/datapulse/onboarding/not_complete";
      }
    }
  } else {
    // If onboarding_progress is nil or an empty array then this client hasn't even started onboarding yet and they requested the url directly. Next page should be intro
    nextPage.url = "/datapulse/onboarding/company_type";
  }
  return nextPage;
};
